module.exports = __webpack_public_path__ + "static/media/6.88d57c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/6.png
// module id = 2060
// module chunks = 0